'use strict';

var _ = require('lodash');
var StatementBoxService = function StatementBoxService(serializeStrategyService, strategyConstants, statementPrintingService) {
  function formatStatement(ruleOriginal, strategyOriginal, strategyGroupOriginal) {
    var result = [];
    var rule = _.cloneDeep(ruleOriginal);
    var strategy = _.cloneDeep(strategyOriginal);
    var strategyGroup = _.cloneDeep(strategyGroupOriginal);
    setStrategyGroupIfClassClosure(strategy, strategyGroup);
    getRuleAndStrategyStatements(rule, strategy, result);
    if (isBlank(result)) {
      return '';
    }
    replaceFirstOperatorOrNewLineWithIf(result);
    return result.join(' ').trim();
  }
  function setStrategyGroupIfClassClosure(strategy, strategyGroup) {
    if (!(isClassClosure(strategy) || isAllocationAuthAvail(strategy)) && strategyGroup) {
      strategy.groups = [strategyGroup];
    }
  }
  function getRuleAndStrategyStatements(rule, strategy, result) {
    var notNullRule = rule || {
      primaryCriteriaLevel: {},
      primaryCriteria: [],
      linkCriteria: []
    };
    serializeStrategyService.parseStrategy(strategy);
    statementPrintingService.createPrintableStatements(result, notNullRule.primaryCriteria, notNullRule.linkCriteria, notNullRule, strategy);
  }
  function getActions(strategy) {
    if (isClassClosure(strategy) || isAllocationAuthAvail(strategy)) {
      return strategy.actionList;
    }
    return strategy.groups && _.head(strategy.groups) ? _.head(strategy.groups).actions : [];
  }
  function getConditions(strategy) {
    if (isClassClosure(strategy) || isAllocationAuthAvail(strategy)) {
      return strategy.commonConditions;
    }
    return strategy.groups && _.head(strategy.groups) ? _.head(strategy.groups).conditions : [];
  }
  function isClassClosure(strategy) {
    return strategy.basis === strategyConstants.StrategyType.CLASS_CLOSURE;
  }
  function isAllocationAuthAvail(strategy) {
    return strategy.basis === strategyConstants.StrategyType.ALLOCATION_AUTH_AVAIL;
  }
  function isBlank(query) {
    return _.isEmpty(query) || _.isEqual(query, ['\n', '\n']);
  }
  function replaceFirstOperatorOrNewLineWithIf(query) {
    query[0] = 'If';
  }
  function isStatementEmpty(rule, strategy) {
    return isRuleEmpty(rule) && isStrategyEmpty(strategy);
  }
  function isRuleEmpty(rule) {
    if (_.isNil(rule)) {
      return true;
    }
    var isPrimaryCriteriaEmpty = _.isNil(rule.primaryCriteria) || _.isUndefined(_.find(rule.primaryCriteria, function (condition) {
      return !(_.isNil(condition) || condition.isEmpty() || _.isNil(condition.criterion));
    }));
    var isLinkCriteriaEmpty = _.isNil(rule.linkCriteria) || _.isUndefined(_.find(rule.linkCriteria, function (criteria) {
      return !_.isNil(criteria) && !criteria.isEmpty();
    }));
    return isPrimaryCriteriaEmpty && isLinkCriteriaEmpty;
  }
  function isStrategyEmpty(strategy) {
    if (_.isNil(strategy)) {
      return true;
    }
    serializeStrategyService.parseStrategy(strategy);
    var strategyConditions = getConditions(strategy);
    var areStatementsEmpty = _.isUndefined(_.find(strategyConditions, function (condition) {
      return !(_.isNil(condition) || condition.isEmpty() || _.isNil(condition.criterion));
    }));
    var strategyActions = getActions(strategy);
    var areActionsEmpty = _.isUndefined(_.find(strategyActions, findNonEmptyCondition));
    return areStatementsEmpty && areActionsEmpty;
  }
  function findNonEmptyCondition(action) {
    var isNotClassClosureAndCriterionIsEmpty = _.isNil(action.fareBasisCode) && _.isNil(action.criterion);
    return action && !action.isEmpty() && !isNotClassClosureAndCriterionIsEmpty;
  }
  return {
    isStatementEmpty: isStatementEmpty,
    formatStatement: formatStatement
  };
};
StatementBoxService.$inject = ['SerializeStrategyService', 'StrategyConstants', 'RuleAndStrategyStatementsPrintingService'];
module.exports = StatementBoxService;